import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import LazyImage from '../../../../ui-core/Image';
// import { blogImageUrl } from '../../../../utils/helpers';
import { IMAGE_CONSTANT } from '../../../../constants/app';
import { blogImageUrl } from '../../../../utils/helpers';
const PodcastsCategories = ({ podcastsCategory }) => {
  const history = useHistory();
  return (
    <>
      <h2 className="sub-head">Categories</h2>
      <ul className="list-inline">
        {podcastsCategory &&
          podcastsCategory.map(categoryItem => {
            const newUrl =
              blogImageUrl +
              categoryItem?.attributes?.icon?.data?.attributes?.url;
            return (
              <li
                onClick={() => {
                  history.push(
                    `/podcasts-listing?filter=${encodeURIComponent(
                      categoryItem?.attributes?.name,
                    )}`,
                  );
                }}
                key={categoryItem.id}
              >
                <LazyImage
                  errorSrc={IMAGE_CONSTANT.placeholderImage}
                  placeholderSrc={IMAGE_CONSTANT.placeholderImage}
                  src={newUrl}
                />
                {categoryItem?.attributes?.name}
              </li>
            );
          })}
      </ul>
    </>
  );
};

PodcastsCategories.propTypes = {
  podcastsCategory: PropTypes.array,
};
export default PodcastsCategories;
